import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCheckmark1"><Path fillRule="evenodd" clipRule="evenodd" d="M19.5408 4.15894C20.0054 4.4576 20.1399 5.07631 19.8412 5.54088L10.8412 19.5409C10.6671 19.8117 10.3733 19.9821 10.0517 19.9988C9.73018 20.0154 9.4203 19.8762 9.21917 19.6248L4.21917 13.3748C3.87416 12.9436 3.94408 12.3143 4.37534 11.9693C4.8066 11.6242 5.4359 11.6942 5.78091 12.1254L9.91147 17.2886L18.1589 4.45936C18.4575 3.99479 19.0762 3.86029 19.5408 4.15894Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark1;
